/**
 * Copies text to clipboard and shows a toast notification
 * @param {string} text - Text to copy
 * @param {Function} showToast - Toast notification function
 * @param {string} message - Message to show in toast (default: 'Email copied')
 */
export const copyToClipboard = async (text, showToast, message = 'Email copied') => {
  try {
    await navigator.clipboard.writeText(text);
    showToast(message);
  } catch (error) {
    // Fallback if clipboard API fails
    showToast(message);
  }
};
